import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =`<template>
<style>

    :host {
        --com-calendar-max-width: 384px;
        --com-calendar-width: 384px;
        --com-calendar-nav-max-width: 404px;
        --com-calendar-legends-flex-direction: column;
    }

    :host #calendarContainer {
        padding-top: 10px;
    }

    :host .overlapping-inner {
        position: relative;
        display: inline-block;
    }

    com-calendar {
        --primary-action: #0079BC;
        --background-component: #F3FDFF;
        --com-calendar-date-weekdays-color: var(--message-grey, #78899E);
        --com-calendar-date-disabled-color: #ACBAC1;
        --com-calendar-date-action-color: #0079BC;
        --com-calendar-date-header-color: #00233C;
        --com-calendar-prices-legend-color: #607682;
        --com-calendar-end-message-color: #00233C;
        margin-left: -10px;
    }

</style>
</template>`;

styleElement.register('com-avl-cal-awakening-calendar-style');